import type {
	CollectionView,
	ViewResponse,
} from '@jira/polaris__domain-collection/src/SrcViewResponse.tsx';
import {
	performDeleteRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';
import { transformView } from './transformView.tsx';

import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';

type ViewToCreate = {
	name: string;
	visualizationType: ViewKind;
	fields?: string[];
};

export const createView = (
	collectionUUID: string,
	viewToCreate: ViewToCreate,
): Promise<CollectionView> =>
	performPostRequest<ViewResponse>(
		`${getJpdViewsServicePathPrefix()}/v1/collections/${collectionUUID}/views`,
		{
			body: JSON.stringify(viewToCreate),
		},
	).then(transformView);

export const deleteView = async (collectionUUID: string, viewUUID: string): Promise<void> => {
	await performDeleteRequest<ViewResponse>(
		`${getJpdViewsServicePathPrefix()}/v1/collections/${collectionUUID}/views/${viewUUID}`,
	);
};
